import { Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SwPush } from '@angular/service-worker';
import { DataService } from '@app/shared/common/auth/data.service';
import { hasEmailSignatureContent, sanitizeEmailSignatureHtml } from '@app/shared/common/email-signature/email-signature-html';
import { UserSignalrService } from '@app/shared/layout/change-status/user-signalr.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { BotFrameworkServiceProxy, ChangeAvatarInput, CommonLookupServiceProxy, CurrentUserProfileEditDto, EmailSignatureDto, IIHandleError, KeysInputDto, LookupTableOutputDto, LookUpTables, NotificationSettingUpdateInput, ProfileServiceProxy, UpdateEmailSignatureInput, UserNotificationSubscriptionInputDto, UserNotificationSubscriptionServiceProxy, UserServiceProxy, UserSettingsDto } from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import swal from 'sweetalert';

@Component({
  selector: 'vf-profile-modal',
  templateUrl: './profile-modal.component.html',
  styleUrls: ['./profile-modal.component.scss']
})
export class ProfileModalComponent extends AppComponentBase implements OnInit, OnDestroy {
  @ViewChild('openProfileModal') openProfileModal: ModalDirective;
  @ViewChild('currentPasswordInput') currentPasswordInput: ElementRef;
  public user: CurrentUserProfileEditDto = new CurrentUserProfileEditDto();
  inputList: any = [];
  conutryId = [];
  currentTab = 0;
  workSchedules: any;
  workLocations: any;
  countries: any;
  allTimezones: LookupTableOutputDto[] = [];
  isdisableCountry = false;
  isShowCalled = false;
  managers: any;
  teams: any;
  shiftId: any;
  isLoading = false;
  imageSource;
  initials = '';
  returnResult: IIHandleError;
  passwordConfirm: string;
  prevName: string;
  prevSurname: string;
  prevShiftId: number;
  prevCountryId: number;
  prevWorkLocationId: number;
  notmatched = false;
  timezoneId = 1;
  managerIcon = '';
  selectedAvatar: ChangeAvatarInput = new ChangeAvatarInput();
  @ViewChild('profileForm') profileForm: NgForm;
  @ViewChild('profileMoreForm') profileMoreForm: NgForm;
  readonly VAPID_PUBLIC_KEY = 'BCUmojq9ROTOQJwZVgCLyAf_koQOk8G0xIAb4J6ywfgB5BN7aIgXTKHD2zKVvMBwGuKw2v88853-QI_OaslTP4M';
  isEmailNotifyOn = true;
  isBotNotifyOn = false;
  isVinnyInstalled = false;
  botInstallUrl = '';
  isActive = false;
  isAccLinked = true;
  readonly emailSignatureFeatureEnabled = AppConsts.emailSignatureFeatureEnabled;
  settings = new UserSettingsDto();
  emailSignatureHtml = '';
  emailSignatureDraft = '';
  hasEmailSignature = false;
  emailSignatureDraftIsEmpty = true;
  isEditingEmailSignature = false;
  isEmailSignatureLoading = false;
  isEmailSignatureSaving = false;
  timeZoneDisplay = '—';
  selectedTimeZoneId: number | undefined;
  isEditingTimeZone = false;
  isTimeZoneSaving = false;
  private botUpdates$ = new Subject<void>();
  private isUpdatingNotificationSettings = false;
  constructor(
    injector: Injector,
    private _profileService: ProfileServiceProxy,
    private dataservice: DataService,
    private _userServiceProxy: UserServiceProxy,
    private _commonLookupAppService: CommonLookupServiceProxy,
    private _botFrameworkService: BotFrameworkServiceProxy,
    private _userSignalrService: UserSignalrService,
    private _appSessionService: AppSessionService,
    private _userNotificationSubscriptionServiceProxy: UserNotificationSubscriptionServiceProxy,
    public swPush: SwPush
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.currentTab = 0;
    this._userSignalrService.botUpdates
      .pipe(takeUntil(this.botUpdates$))
      .subscribe((ev) => {
        if (ev.userId === this.appSession.userId && !this.isUpdatingNotificationSettings) {
          this.getNotificationSettings();
        }
      });
  }

  changeTab(tabNumber): void {
    this.resetData(tabNumber);
  }
  
  isShownModal() {
    if (this.openProfileModal.isShown) {
      this.isActive = false;
      this.openProfileModal.hide();
    }
  }
  private checkIsAccountLinked() {
    this.isLoading = true;
    this._userServiceProxy.getNeedToRelinkUsers().subscribe((result) => {
      this.isLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData.length > 0) {
            result.responseData.forEach(x => {
              if (x.emailAddress === this.appSession.user.emailAddress) {
                this.isAccLinked = false;
              }
            });
          } else {
            this.isAccLinked = true;
            this.dataservice.isAccountLinked.next(true);
          }
        }
      }
    });
  }
  getDropdowns(): void {
    this.isShowCalled = true;
    this.inputList = [
      { filter: '', isEntityIdsNameRequired: false, entityIds: '', lookUpTableName: LookUpTables._12, isInActiveDataRequired: false, sorting: '', skipCount: 0, maxResultCount: 999999 },
      { filter: '', isEntityIdsNameRequired: false, entityIds: '', lookUpTableName: LookUpTables._0, isInActiveDataRequired: false, sorting: '', skipCount: 0, maxResultCount: 999999 },
      { filter: '', isEntityIdsNameRequired: false, entityIds: '', lookUpTableName: LookUpTables._14, isInActiveDataRequired: false, sorting: '', skipCount: 0, maxResultCount: 999999 },
      { filter: '', isEntityIdsNameRequired: false, entityIds: '', lookUpTableName: LookUpTables._5, isInActiveDataRequired: false, sorting: '', skipCount: 0, maxResultCount: 999999 },
      { filter: '', isEntityIdsNameRequired: false, entityIds: '', lookUpTableName: LookUpTables._16, isInActiveDataRequired: false, excludeIds: this.appSession.user.id, sorting: '', skipCount: 0, maxResultCount: 999999 }
    ];
    forkJoin([
      this._commonLookupAppService.getAllForLookupTables(this.inputList)]
    ).subscribe(([result]) => {
      this.managers = result.responseData[4];
      this.workSchedules = result.responseData[0];
      this.teams = result.responseData[1];
      this.countries = result.responseData[2];
      this.allTimezones = result.responseData[3];
      this.getMyProfile();
    });
  }

  private getMyProfile(): void {
    this._profileService.getCurrentUserProfileForEdit().subscribe((result) => {
      if (result.profilePictureUrl) {
        this.imageSource = result.profilePictureUrl;
      }
      this.prevName = result.name;
      this.prevSurname = result.surname;
      this.prevShiftId = result.shiftId;
      this.prevCountryId = result.countryId;
      this.prevWorkLocationId = result.workSiteId;
      this.selectedAvatar.iconUrl = result.iconUrl;
      this.user = result;
      this.selectedTimeZoneId = result.timeZoneId;
      this.timeZoneDisplay = this.getTimeZoneName(result.timeZoneId, result.timezone);
      this.initials = this.getInitials(this.user.name + ' ' + this.user.surname);
      let test = this.managers.filter(x => x.id === result.managerId);
      this.managerIcon = test.length > 0 ? test[0].profilePictureUrl : '';

      if ($('body > *').hasClass('modal-backdrop')) {
        $('body > *').removeClass('modal-backdrop');
      }
      setTimeout(() => {
        this.isShowCalled = false;
        this.setFormPristine(this.profileForm);
        this.setFormPristine(this.profileMoreForm);
        this.isLoading = false;
      }, 1000);
    });
  }

  editEmailSignature(): void {
    if (!this.emailSignatureFeatureEnabled) {
      return;
    }

    this.updateEmailSignatureDraftState(this.emailSignatureHtml);
    this.isEditingEmailSignature = true;
  }

  beginTimeZoneEdit(): void {
    this.selectedTimeZoneId = this.user.timeZoneId;
    this.isEditingTimeZone = true;
  }

  cancelTimeZoneEdit(): void {
    this.selectedTimeZoneId = this.user.timeZoneId;
    this.isEditingTimeZone = false;
  }

  saveTimeZone(): void {
    if (this.isTimeZoneSaving || !this.selectedTimeZoneId) {
      return;
    }

    const input = CurrentUserProfileEditDto.fromJS(this.user.toJSON());
    if (!input) {
      return;
    }

    input.timeZoneId = this.selectedTimeZoneId;
    this.isTimeZoneSaving = true;
    this._profileService.updateCurrentUserProfile(input)
      .pipe(
        takeUntil(this.botUpdates$),
        finalize(() => { this.isTimeZoneSaving = false; })
      )
      .subscribe((result: IIHandleError) => {
        if (result.isError) {
          this.toastr.error(result.errorMessage || 'Time zone could not be updated.', null, this.toastrOptions);
          return;
        }

        this.user.timeZoneId = this.selectedTimeZoneId;
        this.timeZoneDisplay = this.getTimeZoneName(this.selectedTimeZoneId);
        this.isEditingTimeZone = false;
        this.setFormPristine(this.profileForm);
        this.toastr.success('Time zone updated.', null, this.toastrOptions);
      });
  }

  trackByLookupOption(_index: number, option: LookupTableOutputDto): number | undefined {
    return option.id;
  }

  cancelEmailSignatureEdit(): void {
    this.updateEmailSignatureDraftState(this.emailSignatureHtml);
    this.isEditingEmailSignature = false;
  }

  onEmailSignatureDraftChange(html: string): void {
    this.updateEmailSignatureDraftState(html);
  }

  saveEmailSignature(): void {
    // An empty draft is only saveable when it clears an existing signature (the server then removes it).
    const removing = this.emailSignatureDraftIsEmpty;
    if (!this.emailSignatureFeatureEnabled || this.isEmailSignatureSaving || (removing && !this.hasEmailSignature)) {
      return;
    }

    // NSwag emits these inputs as CLASSES (they carry init/toJSON), so an object literal does not
    // satisfy the type - construct it.
    const input: UpdateEmailSignatureInput = new UpdateEmailSignatureInput({
      html: sanitizeEmailSignatureHtml(this.emailSignatureDraft),
      addToNewEmails: true,
      addToRepliesAndForwards: true
    });
    this.isEmailSignatureSaving = true;
    this._profileService.updateEmailSignature(input)
      .pipe(
        takeUntil(this.botUpdates$),
        finalize(() => { this.isEmailSignatureSaving = false; })
      )
      .subscribe(
        (result: EmailSignatureDto) => {
          this.applyEmailSignature(result);
          this.isEditingEmailSignature = false;
          this.toastr.success(removing ? 'Email signature removed.' : 'Email signature saved.', null, this.toastrOptions);
        },
        () => {
          this.toastr.error('Email signature could not be saved. Please try again.', null, this.toastrOptions);
        }
      );
  }

  removeEmailSignature(): void {
    this.updateEmailSignatureDraftState('');
    this.saveEmailSignature();
  }

  private loadEmailSignature(): void {
    if (!this.emailSignatureFeatureEnabled) {
      return;
    }

    this.isEmailSignatureLoading = true;
    this._profileService.getEmailSignature()
      .pipe(
        takeUntil(this.botUpdates$),
        finalize(() => { this.isEmailSignatureLoading = false; })
      )
      .subscribe((result: EmailSignatureDto) => this.applyEmailSignature(result));
  }

  private applyEmailSignature(result: EmailSignatureDto | null): void {
    const html = sanitizeEmailSignatureHtml(result && result.html ? result.html : '');
    this.emailSignatureHtml = html;
    this.updateEmailSignatureDraftState(html);
    this.hasEmailSignature = !!(result && result.hasSignature) && hasEmailSignatureContent(html);
  }

  private updateEmailSignatureDraftState(html: string): void {
    const cleanHtml = sanitizeEmailSignatureHtml(html || '');
    this.emailSignatureDraft = cleanHtml;
    this.emailSignatureDraftIsEmpty = !hasEmailSignatureContent(cleanHtml);
  }

  private getTimeZoneName(id: number | undefined, fallback = '—'): string {
    const selected = this.allTimezones.find((timeZone: LookupTableOutputDto) => timeZone.id === id);
    return selected && selected.name ? selected.name : fallback;
  }

  save(): void {
    if ((this.currentTab === 0 && this.profileForm.valid)) {
      let input = new CurrentUserProfileEditDto();
      input = this.user;
      input.managerId = this.user.managerId ? this.user.managerId[0] : null;
      input.name = this.user.name;
      input.surname = this.user.surname;
      input.shiftId = this.user.shiftId[0];
      input.countryId = this.user.countryId ? this.user.countryId[0] : null;
      input.countryId = this.user.countryId;
      input.timeZoneId = this.user.timeZoneId[0] ? this.user.timeZoneId[0] : null;
      this.isLoading = true;
      this._profileService.updateCurrentUserProfile(input)
        .pipe(finalize(() => { this.isLoading = false; }))
        .subscribe((result: IIHandleError) => {
          this.returnResult = result;
          this.isLoading = false;
          this._appSessionService.init().then(() => {

          });
          if (!this.returnResult.isError) {
            this.resetValues();
            this.isActive = false;
            this.openProfileModal.hide();
            this.checkIfAnySidebarIsOpen();
            this.dataservice.userName.next(input.name);
            let options = this.toastrOptions;
            this.toastr.success('Successfully saved changes to profile', null, options);
          } else {
            this.notmatched = true;
            let options = this.toastrOptions;
            this.toastr.success('Password not matched', null, options);
          }
        });
    } else if (this.currentTab === 0) {
      this.setFormDirty(this.profileForm);
    }
    // else if (this.currentTab === 1) {
    //   this.setFormDirty(this.profileMoreForm);
    // }
  }

  close() {
    if ((this.profileForm && this.currentTab === 0 && this.profileForm.dirty) || (this.profileMoreForm && this.currentTab === 1 && this.profileMoreForm.dirty)) {
      swal({
        className: 'VF-Alerts',
        title: 'Are you sure?',
        text: 'All unsaved changes will be lost',
        buttons: {
          confirm: {
            text: 'Yes',
            closeModal: true,
            value: true,
            visible: true,
            className: 'btn text-uppercase btn-primary text-white btn-block',
          },
          cancel: {
            text: 'No',
            className: 'btn text-uppercase btn-cancel btn-block',
            closeModal: true,
            value: false,
            visible: true,
          }
        }
      }).then((result) => {
        if (result) {
          this.isActive = false;
          this.openProfileModal.hide();
          // if ($('.project-slider').hasClass('show')) {
          //   if (!$('#EditAddedTaskProject').hasClass('show') && !$('#EditAddedTask').hasClass('show')) {
          //     $('#projectSliderExpand').removeClass('d-none');
          //   }
          // }
          this.cancel();
          this.checkIfAnySidebarIsOpen();
          setTimeout(() => {
            this.setFormPristine(this.profileForm);
            this.setFormPristine(this.profileMoreForm);
          }, 500);
        }
      });
    } else {
      this.isActive = false;
      this.openProfileModal.hide();
      this.checkIfAnySidebarIsOpen();
      // if ($('.project-slider').hasClass('show')) {
      //   if (!$('#EditAddedTaskProject').hasClass('show') && !$('#EditAddedTask').hasClass('show')) {
      //     $('#projectSliderExpand').removeClass('d-none');
      //   }
      // }
      setTimeout(() => {
        this.setFormPristine(this.profileForm);
        this.setFormPristine(this.profileMoreForm);
      }, 500);
    }

  }

  private checkIfAnySidebarIsOpen() {
    // use only when you don't need to alter any line of code in this method
    if ($('.right-side-bar-projects').length > 0 ||
      $('.right-side-bar-contacts').length > 0 ||
      $('.right-side-bar-files').length > 0 ||
      $('.task-modal-right').hasClass('show')) {
      $('body').addClass('rightsidebar-open');
    } else {
      $('body').removeClass('rightsidebar-open');
    }
  }

  show() {
    $('body').addClass('task-modal-body');
    this.isActive = true;
    this.currentTab = 0;
    this.isLoading = true;
    this.isEditingEmailSignature = false;
    this.isEditingTimeZone = false;
    this.openProfileModal.show();
    this.getDropdowns();
    this.loadEmailSignature();
    this.checkIsAccountLinked();
    setTimeout(() => {
      if (!$('body').hasClass('rightsidebar-open')) {
        $('body').addClass('rightsidebar-open');
      }
    }, 400);
    // if ($('.project-slider').hasClass('show')) {
    //   $('#projectSliderExpand').addClass('d-none');
    // }
  }

  private resetValues() {
    this.notmatched = false;
    this.user.currentPassword = '';
    this.user.newPassword = '';
    this.passwordConfirm = '';
    setTimeout(() => {
      this.setFormPristine(this.profileForm);
      this.setFormPristine(this.profileMoreForm);
    }, 500);
  }

  resetData(tabNumber: number): void {
    if ((this.currentTab === 0 && this.profileForm.dirty) || (this.currentTab === 1 && this.profileMoreForm.dirty)) {
      swal({
        className: 'VF-Alerts',
        title: 'Are you sure?',
        text: 'All unsaved changes will be lost',
        buttons: {
          confirm: {
            text: 'Yes',
            closeModal: true,
            value: true,
            visible: true,
            className: 'btn text-uppercase btn-primary text-white btn-block',
          },
          cancel: {
            text: 'No',
            className: 'btn text-uppercase btn-cancel btn-block',
            closeModal: true,
            value: false,
            visible: true,
          }
        }
      }).then((result) => {
        if (result) {
          this.currentTab = tabNumber;
          this.cancel();
          setTimeout(() => {
            this.setFormPristine(this.profileForm);
            this.setFormPristine(this.profileMoreForm);
          }, 500);

        }
      });
    } else if (tabNumber === 2) {
      this.currentTab = tabNumber;
      this.getNotificationSettings();
      this.getSettings();
    } else {
      this.currentTab = tabNumber;
      this.cancel();
      setTimeout(() => {
        this.setFormPristine(this.profileForm);
        this.setFormPristine(this.profileMoreForm);
      }, 500);
    }
  }

  getBotInstallUrl() {
    this._botFrameworkService.getBotDownloadUrl().subscribe(result => {
      this.botInstallUrl = result;
    });
  }

  getNotificationSettings() {
    this._profileService.getProfileNotificationSettings().subscribe(result => {
      if (!result.isError) {
        this.isEmailNotifyOn = result.responseData.isEmailNotificationEnabled;
        this.isBotNotifyOn = result.responseData.isTeamsNotificationEnabled;
        this.isVinnyInstalled = result.responseData.isVinnyInstalled;
        this.isLoading = false;
        if (!this.isVinnyInstalled) {
          this.getBotInstallUrl();
        }
      }
    });
  }

  updateNotificationSettings() {
    this.isLoading = true;
    this.isUpdatingNotificationSettings = true;
    // setTimeout(() => {
    //   this.isLoading = false;
    // }, 1000);
    let input = new NotificationSettingUpdateInput();
    input.isEmailNotificationEnabled = this.isEmailNotifyOn;
    input.isTeamsNotificationEnabled = this.isBotNotifyOn;
    this._profileService.updateProfileNotificationSettings(input).subscribe(result => {
      this.isLoading = false;
      this.isUpdatingNotificationSettings = false;
      if (!result.isError) {
        this.getNotificationSettings();
      }
    });
  }

  private getSettings(): void {
    // this.isSaving = true;
    this._userServiceProxy.getUserSettings().subscribe((result) => {
      if (!result.isError) {
        this.settings = result.responseData;
      }
      // this.isSaving = false;
    });
  }

  updateShowBreakSettings(event: any) {
    this.isLoading = true;
    this.settings.showBreak = event.target.checked;
    this._userServiceProxy.createOrUpdateUserSettings(this.settings).subscribe((result) => {
      if (!result.isError) {
        this.isLoading = false;
        let options = this.toastrOptions;
        this.toastr.success('Settings saved successfully!', null, options);
      }
    });
  }

  updateCatchUpEmailSettings(event: any) {
    this.isLoading = true;
    this.settings.showUnreadEmails = event.target.checked;
    this._userServiceProxy.createOrUpdateUserSettings(this.settings).subscribe((result) => {
      if (!result.isError) {
        this.isLoading = false;
        let options = this.toastrOptions;
        this.toastr.success('Settings saved successfully!', null, options);
      }
    });
  }

  cancel() {
    this.user.name = this.prevName;
    this.user.surname = this.prevSurname;
    this.user.shiftId = this.prevShiftId;
    this.user.workSiteId = this.prevWorkLocationId;
    this.user.countryId = this.prevCountryId;
    this.resetValues();
  }
  updateProfile(selectedAvatar: ChangeAvatarInput) {
    this.selectedAvatar = selectedAvatar;
  }

  subscribeToNotifications($event: Event) {
    $event.preventDefault();
    this.swPush.requestSubscription({
      serverPublicKey: this.VAPID_PUBLIC_KEY
    })
      .then(sub => {
        let input: UserNotificationSubscriptionInputDto = new UserNotificationSubscriptionInputDto({
          userId: null,
          endPoint: sub.endpoint,
          keys: new KeysInputDto({
            auth: btoa(String.fromCharCode.apply(null, new Uint8Array(sub.getKey('auth')))),
            p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(sub.getKey('p256dh')))),

          }),
          isDeleted: false,
          deleterUserId: null
        });

        this._userNotificationSubscriptionServiceProxy.createOrUpdateUserNotificationSubscription(input).subscribe(res => {

        });
      })
      .catch(err => console.error('Could not subscribe to notifications', err));
  }

  installBot() {
    window.open(this.botInstallUrl, '_blank');
  }

  relink() {
    this.dataservice.showTokenLink.next();
  }

  syncProfilePic() {
    this.isLoading = true;
    this.imageSource = undefined;
    this._profileService.syncM365UserPhoto().subscribe(result => {
      this.isLoading = false;
      if (!result.isError) {
        this.imageSource = result.responseData;
      }
    });
  }

  ngOnDestroy(): void {
    this.botUpdates$.next();
    this.botUpdates$.complete();
  }
}
